export default "__VITE_ASSET__CZESBuO2__"